import React from 'react';
import { Outlet } from 'react-router-dom';
import { TerminalContractsDraftProvider } from './TerminalContractsDraftContext';

const TerminalContractsDraftLayout = () => {
    return (
        <TerminalContractsDraftProvider>
            <Outlet />
        </TerminalContractsDraftProvider>
    );
};

export default TerminalContractsDraftLayout;